var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-form",
        {
          ref: "editCatTagsForm",
          attrs: { model: _vm.editCatTagsForm, "label-width": "120px" }
        },
        [
          [
            _c(
              "el-tabs",
              {
                on: { "tab-click": _vm.handleClick },
                model: {
                  value: _vm.activeName,
                  callback: function($$v) {
                    _vm.activeName = $$v
                  },
                  expression: "activeName"
                }
              },
              [
                _c(
                  "el-tab-pane",
                  {
                    attrs: {
                      label: "标签排序（非幼猫）- 从左到右排序（从先到后）",
                      name: "first"
                    }
                  },
                  [
                    _c(
                      "vuedraggable",
                      {
                        on: { end: _vm.end },
                        model: {
                          value: _vm.editCatTagsForm.tags,
                          callback: function($$v) {
                            _vm.$set(_vm.editCatTagsForm, "tags", $$v)
                          },
                          expression: "editCatTagsForm.tags"
                        }
                      },
                      _vm._l(_vm.editCatTagsForm.tags, function(tag) {
                        return _c(
                          "el-tag",
                          {
                            key: tag.id,
                            staticClass: "link",
                            attrs: { "disable-transitions": false },
                            on: {
                              close: function($event) {
                                return _vm.handleClose(tag)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(tag.tag) +
                                "\n            "
                            )
                          ]
                        )
                      }),
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }